<template>
    <div class="body-view-month">
        <div class="blur-mask" v-if="vipInfo.userRole==='normal'"></div>
        <div class="items-week">
            <div class="item-week"
                 v-for="(weekItem, weekIndex) in weekItems" :key="weekIndex">
                周{{ weekItem }}
            </div>
        </div>
        <div ref="items-day" class="items-day">
            <div class="row-item-week"
                 :style="{'min-height': 'calc(100% / ' + monthChainArray.length + ')'}"
                 v-for="(rowItem) in monthChainArray">
                <!-- 每周-每天 -->
                <div class="item-days" >
                    <div class="item-day my-cursor"
                         :style="{'background': selectDayStr === dayItem.date ? 'rgba(255, 239, 180, 0.4)': ''}"
                         @click.stop="submitDay(dayItem)"
                         v-for="(dayItem) in rowItem.dayItems">
                        <div class="item-day-title" :style="{'opacity': dayItem.sameMonth ? 1: 0.25}">
                            <div class="text-day" :style="[
                                {'background': selectDayStr === dayItem.date ? '#F7C2C7': ''},
                                {'border-color': dayItem.isToday ? '#F7C2C7': ''},
                            ]">
                                <template v-if="dayItem.isToday">
                                    今
                                </template>
                                <template v-else>
                                    {{ dayItem.day }}
                                </template>
                            </div>
                            <div class="text-vice-day">{{ dayItem.viceDay }}</div>
                            <div class="text-work-day " v-if="dayItem.isWork === 1">班</div>
                            <div class="text-rest-day" v-else-if="dayItem.isWork === 2">休</div>
                        </div>
                    </div>
                </div>

                <div class="row-item-matter" :style="{'margin-top': -rowWeekHeight + 'px'}">
                    <div class="chain-row"
                         v-for="(chainItem) in rowItem.chainArray">
                        <div class="item-matter"
                             :style="[
                                     {width: 'calc((100% / 7) * '+ (1+ matterItem.endDayIndex - matterItem.startDayIndex) +')'},
                                     {marginLeft: 'calc((100% / 7) * '+ matterItem.leftNum +')'}
                                 ]"
                             v-for="(matterItem) in chainItem">

                            <div class="text-matter my-cursor"
                                 :style="[
                                     {'background': matterItem.color},
                                     {'opacity': !matterItem.sameMonth || matterItem.state === 1 || matterItem.state === 2 ? 0.25: 1}
                                 ]"
                                 @click.stop="submitMatter(matterItem)">
                                {{ matterItem.text}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import listShowInfo from "@/utils/List/listShowInfo";
import SetChainItems from "@/utils/View/SetChainItems";
import {mapState} from "vuex";

export default {
    name: "ViewMonth",

    data(){
        return {
            dayState: false,
            weekItems: ["一", "二", "三", "四", "五", "六", "日"],
            todayStr: "",
            solarMonth: {},
            dayItems: [],
            selectDayStr: "",
            monthChainArray: [],
            rowWeekHeight: 0,
        }
    },
    computed: {
        ...mapState(["vipInfo"]),
        ...mapState("listModules", ["categoryShowId"])
    },

    methods: {

        getCycleDayItems: function(monthType){
            if(monthType === "prev"){
                this.solarMonth = this.solarMonth.next(-1);
            }else if(monthType === "next"){
                this.solarMonth = this.solarMonth.next(1);
            }else if(monthType === "current"){
                this.solarMonth = SolarMonth.fromDate(new Date());
            }
            this.selectDayStr = "";
            // 获取每一天
            this.updateMatterItem();
        },
        updateMatterItem: function(){
            const monthNum = this.solarMonth.getMonth();
            let dayItems = this.$Utils.getMonthDays(this.solarMonth);
            const cycleFirstDay = dayItems[0].toYmd();
            dayItems.forEach((item, index, array)=>{
                const itemYmd = item.toYmd();
                const isWork = this.$Utils.checkWork(itemYmd);
                let sameMonth = item.getMonth() === monthNum;
                let isToday = itemYmd === this.todayStr;
                if(isToday && this.selectDayStr === ""){
                    this.selectDayStr = itemYmd;
                }
                const viceItem = this.$Utils.getViceDay(item);
                array[index] = {
                    day: item.getDay(),
                    viceDay: viceItem.viceDay,
                    viceColor: viceItem.viceColor,
                    isWork: isWork,
                    weekday: item.getWeekInChinese(),
                    sameMonth: sameMonth,
                    isToday: isToday,
                    date: itemYmd,
                    matterArray: [],
                }
            })

            listShowInfo.setMonthDays(dayItems);
            this.dayItems = dayItems;
            this.setChainArray();
            // 标题日期
            const titleDate = this.solarMonth.getYear() + "年" + this.$Utils.addZero(this.solarMonth.getMonth()) + "月";
            // 周期第一天
            if(this.selectDayStr === ""){
                this.selectDayStr = cycleFirstDay;
            }
            this.submitCycle(titleDate, cycleFirstDay);

        },

        setChainArray: function(){
            let chainCount;
            if(this.rowWeekHeight === 0){
                const itemsDay = this.$refs["items-day"];
                let weekCount = this.dayItems.length / 7;
                const titleHeight = Math.trunc(width_scale * 0.34);
                const rowWeekHeight = Math.trunc((itemsDay.offsetHeight / weekCount) - titleHeight - 2);
                chainCount = Math.trunc((rowWeekHeight - 4) / 24);
                this.rowWeekHeight = rowWeekHeight;
            }else{
                chainCount = Math.trunc((this.rowWeekHeight - 4) / 24);
            }
            this.monthChainArray = SetChainItems.setChainItems(this.dayItems, chainCount, "month");
        },

        submitCycle: function(titleDate, cycleFirstDay){

            this.$emit("cycleEvent", {
                titleDate: titleDate,
                cycleFirstDay: cycleFirstDay,
                selectDayStr: this.selectDayStr,
            });
        },
        submitDay: function(dayItem){
            this.selectDayStr = dayItem.date;
            this.$emit("dayEvent", dayItem);

        },
        submitMatter: function(matterItem){
            if(matterItem.matterItem){
                this.$emit("matterEvent", matterItem.matterItem);
            }else{
                this.submitDay(this.dayItems[matterItem.startDayIndex]);
            }
        },
    },
    mounted(){
        this.todayStr = Solar.fromDate(new Date()).toYmd();
        this.getCycleDayItems("current");
        setTimeout(()=>{
            if(this.vipInfo.userRole === "normal"){
                this.$PopupToast("非会员用户，不能使用月视图");
            }
        })

    },
}
</script>

<style scoped>
div.body-view-month{
    width: 100%;
    height: calc(100% - 0.56rem);
    position: relative;
}
div.items-week{
    width: 100%;
    height: 0.46rem;
    display: flex;
}

div.item-week{
    width: 100%;
    font-size: 0.15rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.46rem;
    text-align: center;
    box-sizing: border-box;
    border-top: #EEEEEE solid 0.01rem;
}

div.items-day{
    width: 100%;
    height: calc(100% - 0.46rem);
    display: flex;
    flex-wrap: wrap;
}
div.row-item-week{
    width: 100%;
    display: inline;
    position: relative;
}


div.item-days{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
}

div.item-day{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

div.item-day:hover{
    background: rgba(255, 239, 180, 0.2);
}
div.item-day-title{
    width: 100%;
    height: 0.34rem;
    display: flex;
    align-items: center;
    gap: 0.05rem;
}
div.text-day{
    width: 0.24rem;
    height: 0.24rem;
    font-size: 0.14rem;
    font-family: PF-Medium, sans-serif;
    font-weight: bold;
    text-align: center;
    line-height: 0.24rem;
    color: #333333;
    border-radius: 50%;
    border: 0.02rem solid transparent;
    margin-left: 0.05rem;
}

div.text-vice-day{
    flex: 1;
    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;
    /*color: #999999;*/
}
div.text-work-day, div.text-rest-day{
    width: 0.2rem;

    font-size: 0.14rem;
    font-family: PF-Medium, sans-serif;
    text-align: center;
    margin-right: 0.05rem;
}
div.text-work-day{
    color: #06CE90;
}
div.text-rest-day{
    color: #E13E39;
}

div.row-item-matter{
    width: 100%;
    height: calc(100% - 0.34rem - 4px);
    padding: 2px 0;
    box-sizing: border-box;
    z-index: 1;
    position: relative;
}
div.chain-row{
    width: 100%;
    height: 24px;
    font-size: 0;
}

div.item-matter{
    height: 24px;
    padding-bottom: 3px;
    padding-left: 0.05rem;
    padding-right: 0.05rem;
    box-sizing: border-box;
    display: inline-block;
}
div.text-matter{
    width: 100%;
    height: 21px;
    border-radius: 0.04rem;

    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 21px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    box-sizing: border-box;
    padding: 0 0.08rem;
}
div.blur-mask{
    width: 100%;
    height: 100%;
    backdrop-filter: blur(5px);

    z-index: 10;
    position: absolute;
}
</style>